import React, { FC } from 'react';
import { MedicalHoItemCategory } from '@/modules/surgicalEvent';
import { useTranslator } from '@ianesthesie-kit/core';
import { Box, Tooltip } from '@mui/material';
import * as Icons from './icons';

export type MedicalCategoryIconKey =
  | Exclude<MedicalHoItemCategory, MedicalHoItemCategory.BILLING>
  | 'ALLERGIES';

const IconMap: { [key in MedicalCategoryIconKey]: FC } = {
  [MedicalHoItemCategory.GI]: Icons.Stomach,
  [MedicalHoItemCategory.RENAL]: Icons.Stomach,
  [MedicalHoItemCategory.CARDIO_VASCULAR]: Icons.Heart,
  [MedicalHoItemCategory.PULMONARY]: Icons.Lungs,
  [MedicalHoItemCategory.NEURO]: Icons.Neuro,
  [MedicalHoItemCategory.HEMATO]: Icons.Hemato,
  [MedicalHoItemCategory.ENDOCRINE]: Icons.Heart,
  [MedicalHoItemCategory.GYN]: Icons.Hemato,
  [MedicalHoItemCategory.OBSTETRIC]: Icons.Hemato,
  [MedicalHoItemCategory.ENT]: Icons.Neuro,
  [MedicalHoItemCategory.FAMILY]: Icons.Family,
  [MedicalHoItemCategory.GENERAL]: Icons.MedicalEquipment,
  [MedicalHoItemCategory.SURGICAL]: Icons.Scalpel,
  [MedicalHoItemCategory.ANESTHESIA]: Icons.OxygenMask,
  ALLERGIES: Icons.HighRisk
};

export const MedicalHoCategoryIcon = ({
  category,
  tooltip
}: {
  category: MedicalHoItemCategory | 'ALLERGIES' | undefined;
  tooltip?: boolean;
}) => {
  const translate = useTranslator();
  if (category === MedicalHoItemCategory.BILLING) {
    return null;
  }
  const Icon = (category && IconMap[category]) || null;

  if (!Icon) {
    return null;
  }

  if (tooltip) {
    return (
      <Tooltip
        title={translate(
          `doctor-dashboard.medical.ho.item.category.${category?.toLowerCase()}`
        )}
      >
        <Box
          component="span"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Icon />
        </Box>
      </Tooltip>
    );
  }

  return <Icon />;
};
